import axiosInstance from "../../axiosInstance";
import {
  AdminLeaveBalanceResponse,
  AddOpeningBalancePayload,
  EditOpeningBalancePayload,
  AdjustOpeningBalancePayload,
  AdjustOpeningBalanceResponse,
  OpeningBalanceLot,
  EmployeeLeaveBalance,
} from "types/leaveBalance";

export const getAdminLeaveBalances = async (
  appUserUuid: string,
  year?: number
): Promise<AdminLeaveBalanceResponse> => {
  const response = await axiosInstance.get(`/people/employees/${appUserUuid}/leave-balances/admin`, {
    params: year ? { year } : undefined,
  });
  return response.data;
};

// One-time per Employee + Leave Type — there is no Leave Year field, the
// backend derives the Worklap accounting year from the org's current date.
export const addOpeningBalance = async (
  appUserUuid: string,
  payload: AddOpeningBalancePayload
): Promise<OpeningBalanceLot> => {
  const response = await axiosInstance.post(`/people/employees/${appUserUuid}/opening-balances`, payload);
  return response.data;
};

// Only valid when the row's directlyEditable flag is true.
export const editOpeningBalance = async (
  appUserUuid: string,
  openingBalanceUuid: string,
  payload: EditOpeningBalancePayload
): Promise<OpeningBalanceLot> => {
  const response = await axiosInstance.put(
    `/people/employees/${appUserUuid}/opening-balances/${openingBalanceUuid}`,
    payload
  );
  return response.data;
};

// Only valid when the row's adjustable flag is true — a CREDIT/DEBIT delta,
// not a direct edit of the stored balance.
export const adjustOpeningBalance = async (
  appUserUuid: string,
  openingBalanceUuid: string,
  payload: AdjustOpeningBalancePayload
): Promise<AdjustOpeningBalanceResponse> => {
  const response = await axiosInstance.post(
    `/people/employees/${appUserUuid}/opening-balances/${openingBalanceUuid}/adjustments`,
    payload
  );
  return response.data;
};

// Aggregate-only self-view — never exposes Automatic Credit / Opening
// Balance source detail.
export const getMyLeaveBalances = async (year?: number): Promise<EmployeeLeaveBalance[]> => {
  const response = await axiosInstance.get('/people/me/leave-balances', {
    params: year ? { year } : undefined,
  });
  return response.data;
};
